import { css, html } from 'lit';
import '../../library/elements/d-section';
import '../../library/elements/d-smooth-resize';
import '../../library/fields/d-view-html';
import { customElement, property } from 'lit/decorators.js';
import { BaseDialog } from 'src/library/components/BaseDialog';
import type { TemplateDialogInput } from './template-dialog-input';
import type { TemplateDialogResult } from './template-dialog-result';
import type { DialogActionInput } from 'src/library/components/DialogActionInput';
import { t } from 'src/i18n';

/**
 *
 * STATUS OK
 */
@customElement('d-template-dialog')
export class DTemplateDialog extends BaseDialog<TemplateDialogInput, TemplateDialogResult> {
  @property({ type: String })
  title = '';
  @property({ type: String })
  content = '';
  @property({ type: Number })
  width = 764;
  static styles = [
    ...BaseDialog.styles,
    css`
      d-view-html {
        pointer-events: none;
      }
    `,
  ];

  protected get calculatedFooterActions(): DialogActionInput[] {
    return [
      { name: t('common:cancel'), action: 'cancel' },
      { name: t('templates.insertTemplate'), action: 'insert', main: true },
    ];
  }

  renderBody() {
    return html`
      <d-section>
        <d-smooth-resize>
          <d-view-html .value=${this.content}></d-view-html>
        </d-smooth-resize>
      </d-section>
    `;
  }

  protected fetchResult(detail: string | undefined): TemplateDialogResult {
    return {
      action: detail === 'insert' ? 'done' : 'cancel',
    };
  }

  protected initializeDialog(input: TemplateDialogInput) {
    this.title = input.title;
    this.content = input.content;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-template-dialog': DTemplateDialog;
  }
}
